import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { MethodSection } from './MethodSection';
import { WhatYouGet } from './WhatYouGet';
import { AudienceSection } from './AudienceSection';
import { PriceSection } from './PriceSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-brand-light font-sans selection:bg-brand-accent selection:text-brand-darker" data-id="element-130">
      <HeroSection data-id="element-131" />
      <ProblemSection data-id="element-132" />
      <MethodSection data-id="element-133" />
      <WhatYouGet data-id="element-134" />
      <AudienceSection data-id="element-135" />
      <PriceSection data-id="element-136" />
      <Footer data-id="element-137" />
    </div>;
}